import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	options: {
		display: 'flex',
		flexDirection: 'column',
		maxHeight: 240,
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	optionButton: {
		width: '100%',
		justifyContent: 'flex-start',
		fontWeight: THEME.typography.fontWeights.standard,
		fontSize: THEME.typography.fontSizes.sm,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		borderRadius: 0,
		height: 'auto',
		color: THEME.colors.text.main,
	},
	optionButtonSelected: {
		backgroundColor: THEME.colors.hover.light,
		fontWeight: THEME.typography.fontWeights.bold,
	},
});
